import React, { useRef, useEffect } from 'react';

function loadScript(src, id) {
  return new Promise((resolve) => {
    if (document.getElementById(id)) { resolve(); return; }
    const s = document.createElement('script');
    s.id = id; s.src = src; s.async = true; s.onload = resolve;
    document.head.appendChild(s);
  });
}

export function RecaptchaV2({ siteKey, onToken }) {
  const ref = useRef(null);
  useEffect(() => {
    let cancelled = false;
    const render = () => {
      if (!cancelled && ref.current && !ref.current.hasChildNodes() && window.grecaptcha?.render) {
        window.grecaptcha.render(ref.current, { sitekey: siteKey, callback: onToken, 'expired-callback': () => onToken('') });
      }
    };
    if (window.grecaptcha?.render) render();
    else {
      window.__naturRcLoad = render;
      loadScript('https://www.google.com/recaptcha/api.js?onload=__naturRcLoad&render=explicit', 'recaptcha-v2-script');
    }
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [siteKey]);
  return <div ref={ref} className="flex justify-center my-3" data-testid="recaptcha-v2" />;
}

export async function executeV3(siteKey, action) {
  await loadScript(`https://www.google.com/recaptcha/api.js?render=${siteKey}`, 'recaptcha-v3-script');
  await new Promise((r) => window.grecaptcha.ready(r));
  return window.grecaptcha.execute(siteKey, { action });
}
